import type { HexString } from "@/types/general.types";

export enum TokenType {
  STANDARD = "erc20",
  NFT = "erc721",
  MULTI = "erc1155",
}

export interface StandardTokenResponseType {
  contractAddress: HexString;
  tokenBalance: HexString;
}

export interface StandardTokenType {
  balance: number; // The balance is a string (to handle large numbers or decimals safely)
  name: string | undefined; // The name of the token
  symbol: string | undefined; // The symbol of the token
  tokenAddress: HexString; // The Ethereum token address
  decimals: number;
  logoUrl: string | undefined;
}
